// import React, { useState } from "react";
// import { MainLayout } from "../layout/MainLayout";
// import {
//   Card,
//   FormInput,
//   Button,
//   Alert,
//   FormGroup,
// } from "../ui/base-components";

// const RegisterUser = () => {
//   const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
//   const [formData, setFormData] = useState({
//     username: "",
//     password: "",
//     confirmPassword: "",
//   });
//   const [message, setMessage] = useState({ type: "", text: "" });

//   const handleChange = (e) => {
//     setFormData((prev) => ({
//       ...prev,
//       [e.target.id]: e.target.value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setMessage({ type: "", text: "" });

//     if (formData.password !== formData.confirmPassword) {
//       setMessage({ type: "error", text: "Passwords do not match" });
//       return;
//     }

//     try {
//       const formPayload = new FormData();
//       formPayload.append("email", formData.username);
//       formPayload.append("password", formData.password);
//       formPayload.append("confirmPassword", formData.confirmPassword);

//       const response = await fetch(`${apiRoot}/api/user`, {
//         method: "POST",
//         body: formPayload,
//       });

//       if (!response.ok) {
//         const errorData = await response.json();
//         throw new Error(errorData.error || "Failed to register");
//       }

//       setMessage({ type: "success", text: "User created successfully!" });
//       setFormData({ username: "", password: "", confirmPassword: "" });
//     } catch (error) {
//       setMessage({
//         type: "error",
//         text: error.message || "Failed to register",
//       });
//     }
//   };

//   return (
//     <MainLayout>
//       <div className="p-6 mt-4">
//         <div className="max-w-md mx-auto">
//           <Card>
//             <div className="space-y-6">
//               <div>
//                 <h2 className="text-2xl font-bold text-gray-900">
//                   Register New User
//                 </h2>
//                 <p className="mt-1 text-sm text-gray-600">
//                   Create a new user account by providing the required
//                   information.
//                 </p>
//               </div>

//               {message.text && (
//                 <Alert type={message.type} message={message.text} />
//               )}

//               <form onSubmit={handleSubmit} className="space-y-6">
//                 <FormGroup>
//                   <FormInput
//                     id="username"
//                     label="Username"
//                     type="text"
//                     value={formData.username}
//                     onChange={handleChange}
//                     required
//                   />

//                   <FormInput
//                     id="password"
//                     label="Password"
//                     type="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                   />

//                   <FormInput
//                     id="confirmPassword"
//                     label="Confirm Password"
//                     type="password"
//                     value={formData.confirmPassword}
//                     onChange={handleChange}
//                     required
//                   />
//                 </FormGroup>

//                 <Button type="submit" className="w-full">
//                   Register User
//                 </Button>
//               </form>
//             </div>
//           </Card>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default RegisterUser;
import React, { useState } from "react";
import { MainLayout } from "../layout/MainLayout";
import { UserPlus, AlertCircle, CheckCircle2, User, Lock, Eye, EyeOff } from "lucide-react";

const RegisterUser = () => {
  const apiRoot = process.env.REACT_APP_API_ROOT_OPERATIONAL;
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    confirmPassword: "",
  });
  const [message, setMessage] = useState({ type: "", text: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.id]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ type: "", text: "" });
    setIsLoading(true);

    if (formData.password !== formData.confirmPassword) {
      setMessage({ type: "error", text: "Passwords do not match" });
      setIsLoading(false);
      return;
    }

    try {
      const formPayload = new FormData();
      formPayload.append("email", formData.username);
      formPayload.append("password", formData.password);
      formPayload.append("confirmPassword", formData.confirmPassword);

      const response = await fetch(`${apiRoot}/api/user`, {
        method: "POST",
        body: formPayload,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Failed to register");
      }

      setMessage({ type: "success", text: "User created successfully!" });
      setFormData({ username: "", password: "", confirmPassword: "" });
    } catch (error) {
      setMessage({
        type: "error",
        text: error.message || "Failed to register",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Page Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl mb-6 shadow-lg">
              <UserPlus className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-4">
              Register New User
            </h1>
            <p className="text-lg text-slate-600 max-w-xl mx-auto">
              Create a new user account by providing the required information
            </p>
          </div>

          {/* Main Form Card */}
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
            {/* Card Header */}
            <div className="bg-gradient-to-br from-blue-600 to-indigo-600 p-6 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="flex items-center gap-3">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl">
                    <UserPlus className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white">Create User Account</h2>
                    <p className="text-white/80 text-sm">Fill in the details to register a new user</p>
                  </div>
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
            </div>

            {/* Card Content */}
            <div className="p-8">
              {/* Alert Messages */}
              {message.text && (
                <div className={`mb-6 p-4 rounded-xl border flex items-center gap-3 ${
                  message.type === "success" 
                    ? "bg-green-50 border-green-200 text-green-700" 
                    : "bg-red-50 border-red-200 text-red-700"
                }`}>
                  {message.type === "success" ? (
                    <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
                  ) : (
                    <AlertCircle className="w-5 h-5 flex-shrink-0" />
                  )}
                  <p className="text-sm font-medium">{message.text}</p>
                </div>
              )}

              {/* Form */}
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Username Field */}
                <div>
                  <label
                    htmlFor="username"
                    className="block text-sm font-semibold text-slate-700 mb-2"
                  >
                    Username
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <User className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type="text"
                      id="username"
                      value={formData.username}
                      onChange={handleChange}
                      className="w-full pl-10 pr-4 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                      placeholder="Enter username"
                      required
                    />
                  </div>
                </div>

                {/* Password Field */}
                <div>
                  <label
                    htmlFor="password"
                    className="block text-sm font-semibold text-slate-700 mb-2"
                  >
                    Password
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Lock className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type={showPassword ? "text" : "password"}
                      id="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="w-full pl-10 pr-12 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                      placeholder="Enter password"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600"
                    >
                      {showPassword ? (
                        <EyeOff className="h-5 w-5" />
                      ) : (
                        <Eye className="h-5 w-5" />
                      )}
                    </button>
                  </div>
                </div>

                {/* Confirm Password Field */}
                <div>
                  <label
                    htmlFor="confirmPassword"
                    className="block text-sm font-semibold text-slate-700 mb-2"
                  >
                    Confirm Password
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Lock className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      className="w-full pl-10 pr-12 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                      placeholder="Confirm password"
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-slate-400 hover:text-slate-600"
                    >
                      {showConfirmPassword ? (
                        <EyeOff className="h-5 w-5" />
                      ) : (
                        <Eye className="h-5 w-5" />
                      )}
                    </button>
                  </div>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isLoading}
                  className="group w-full py-3 px-6 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 
                    text-white rounded-xl font-semibold transition-all duration-200 flex items-center justify-center gap-3
                    disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  {isLoading ? (
                    <>
                      <svg
                        className="animate-spin h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                        />
                      </svg>
                      Creating User...
                    </>
                  ) : (
                    <>
                      <UserPlus className="w-5 h-5 group-hover:scale-110 transition-transform duration-200" />
                      Register User
                    </>
                  )}
                </button>
              </form>

              {/* Password Requirements */}
              <div className="mt-8 p-4 bg-slate-50 rounded-xl border border-slate-200">
                <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2">
                  <AlertCircle className="w-4 h-4 text-blue-600" />
                  Password Requirements
                </h3>
                <div className="grid md:grid-cols-2 gap-2 text-sm text-slate-600">
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                    <span>Use a strong, unique password</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                    <span>Ensure passwords match exactly</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                    <span>Username should be unique</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                    <span>All fields are required</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default RegisterUser;